<div class="card-button" [hidden]="actionButtons.length == 0">
    <button  *ngFor="let item of actionButtons" style="height: 30px !important;" class="btn f-11 position-relative top--3px" [hidden]="item.buttonText==''"
        (click)="onUserAction(item.userAction);" [ngClass]="item.buttonClass">
        {{ item.buttonText }}
    </button>
</div>
